import * as React from 'react';
import { IconChevronDownSmall16, IconChevronUpSmall16 } from '@cian/ui-kit';

import * as styles from './ExpandButton.css';
import { TextButton } from '../TextButton';

export interface IExpandButtonProps {
  expanded: boolean;
  onToggle(): void;
  expandText?: string;
  collapseText?: string;
}

export const ExpandButton: React.FC<IExpandButtonProps> = ({
  expanded,
  onToggle,
  expandText = 'Показать ещё',
  collapseText = 'Свернуть',
}) => {
  return (
    <div className={styles['button']}>
      <TextButton onClick={onToggle}>
        {expanded ? collapseText : expandText}
        <span className={styles['icon']}>
          {expanded ? <IconChevronUpSmall16 color="primary_100" /> : <IconChevronDownSmall16 color="primary_100" />}
        </span>
      </TextButton>
    </div>
  );
};
